<template>
  <div class="add-user wrapper">
    <div class="content-page">
      <div class="content">
        <!-- <div class="row" style="margin-bottom: 20px;">
          <div class="col-xl-6">用户管理</div>
          <div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;">
            <Breadcrumb></Breadcrumb>
          </div>
        </div> -->
        <el-card>
          <div class="explain">个人信息</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="登录名" prop="username">
                  <el-input :disabled="true" placeholder="6-16位,不含特殊字符" v-model="ruleForm.username"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="真实姓名" prop="realName">
                  <el-input v-model="ruleForm.realName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="登录密码" prop="password">
                  <el-input show-password v-model="ruleForm.password"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="确认密码" prop="verifyPassword">
                  <el-input show-password v-model="ruleForm.verifyPassword"></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="身份证号" prop="idCard">
                  <el-input v-model="ruleForm.idCard"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="出生日期" prop="birthday">
                  <el-date-picker v-model="ruleForm.birthday" type="date" placeholder="选择出生日期"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="Email" prop="email">
                  <el-input v-model="ruleForm.email"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="办公电话" prop="phone">
                  <el-input placeholder="请输入021-XXXXXXX格式" v-model="ruleForm.phone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="手机" prop="mobile">
                  <el-input v-model="ruleForm.mobile"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别" prop="sex">
                  <el-select v-model="ruleForm.sex" clearable placeholder="请选择">
                    <el-option v-for="item in sexOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="行政职务" prop="administrativePost">
                  <el-input v-model="ruleForm.administrativePost"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职称" prop="rank">
                  <el-select v-model="ruleForm.rank" clearable placeholder="请选择">
                    <el-option v-for="item in jobTitleOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="所在单位" prop="unitId">
              <el-cascader v-model="ruleForm.regionId" clearable disabled :props="{ value: 'id', label: 'name' }" :options="areaOptions" @change="areaChange"></el-cascader>
              <!-- <el-select v-model="ruleForm.unitId" :disabled="unitOptions.length===0" clearable filterable placeholder="请选择">
                <el-option v-for="item in unitOptions" :key="item.id" :label="item.unitName" :value="item.id"></el-option>
              </el-select> -->
							<el-select v-model="ruleForm.unitId" disabled clearable filterable placeholder="请选择">
							  <el-option v-for="item in unitOptions" :key="item.id" :label="item.unitName" :value="item.id"></el-option>
							</el-select>
            </el-form-item>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="照片" prop="headImage">
                  <UpLoadImgOne @img-event="e => changeData('headImage', e)" :value="ruleForm.headImage"></UpLoadImgOne>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="是否禁用" prop="state">
                  <el-switch v-model="ruleForm.state" active-color="#13ce66" inactive-color="#ff4949"></el-switch><span style="margin-left: 10px;">{{ruleForm.state == 1?'启用':'禁用'}}</span>
                </el-form-item>
              </el-col> -->
            </el-row>

            <el-form-item label="介绍" prop="introduc">
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入介绍" v-model="ruleForm.introduc" maxlength="2000" show-word-limit></el-input>
            </el-form-item>

            <!-- <el-form-item label="选择角色" prop="roleId">
              <el-checkbox-group v-model="ruleForm.roleId">
                <el-checkbox :label="item.id" v-for="(item, index) in roleList" :key="index">{{item.roleName}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item> -->
						
          </el-form>
          <div class="btn-wrap" style="text-align: center;">
            <el-button size="small" type="primary" @click="newUser">保存</el-button>
            <el-button size="small" type="primary" @click="goBack">返回</el-button>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/views/backstage/components/Breadcrumb.vue";
import UpLoadImgOne from "@/components/upLoad/UpLoadImgOne.vue";
import { getUserInfo } from '@/api/after/login';
import {
  getRoleList,
  getPlatformInformationData,
  getAreaTree,
  getUnitListByArea,
  addUser,
  editUser,
  getUserDetail,
} from "@/api/after/systemManagement.js";
export default {
  components: {
    Breadcrumb,
    UpLoadImgOne,
  },
  data() {
    var validateUsername = (rule, value, callback) => {
      // if (this.actionType === "修改用户") {
        callback();
      // } else {
      //   let regexp = /^[a-zA-Z0-9]{6,16}$/;
      //   if (value === "") {
      //     callback(new Error("请输入登录名"));
      //   } else if (!regexp.test(value)) {
      //     callback(new Error("登录名长度为6-16位且只能包含英文字母、数字"));
      //   } else {
      //     callback();
      //   }
      // }
    };

    var validatePassword = (rule, value, callback) => {
      if (this.actionType === "修改用户") {
        if (!value) {
          callback();
        } else if (value.length < 6) {
          callback(new Error("密码长度不能小于6"));
        } else {
          callback();
        }
      } else {
        if (!value) {
          callback(new Error("请输入密码"));
        } else if (value.length < 6) {
          callback(new Error("密码长度不能小于6"));
        } else {
          callback();
        }
      }
    };

    var validateVerifyPassword = (rule, value, callback) => {
      if (value == this.ruleForm.password) {
        callback();
      } else {
        callback(new Error("两次密码不同！"));
      }
    };

    var validateIdCard = (rule, value, callback) => {
      let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      if (!value) {
        callback();
      } else if (_IDRe18.test(value) || _IDre15.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的身份证号！"));
      }
    };

    var validateEmail = (rule, value, callback) => {
      let regexp = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!value) {
        callback();
      } else if (regexp.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的电子邮箱！"));
      }
    };

    var validatePhone = (rule, value, callback) => {
      let regexp = /^\d{3}-\d{7,8}|\d{4}-\d{7,8}$/;
      if (!value) {
        callback();
      } else if (regexp.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的固定电话号码！"));
      }
    };

    var validateMobile = (rule, value, callback) => {
      let regexp = /^1(3[0-9]|4[57]|5[0-35-9]|7[0678]|8[0-9])\d{8}$/;
      if (!value) {
        callback();
      } else if (regexp.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的手机号码！"));
      }
    };
		return {
			ruleForm: {
				username: '',
				realName: '',
				password: '',
				verifyPassword: '',
				idCard: '',
				birthday: '',
				email: '',
				phone: '',
				mobile: '',
				sex: '',
				administrativePost: '',
				rank: '',
				unitId: '',
				headImage: '',
				state: true,
				introduc: '',
				roleId: [],
				regionId: []
			},
			rules: {
				username: [{ required: true, validator: validateUsername, trigger: 'blur' }],
				password: [{ required: false, validator: validatePassword, trigger: 'blur' }],
				verifyPassword: [{ required: false, validator: validateVerifyPassword, trigger: 'blur' }],
				idCard: [{ validator: validateIdCard, trigger: 'blur' }],
				email: [{ validator: validateEmail, trigger: 'blur' }],
				phone: [{ validator: validatePhone, trigger: 'blur' }],
				mobile: [{ validator: validateMobile, trigger: 'blur' }],
				unitId:[{required: true, message: '请选择单位!', trigger: 'change'}]
			},
			// roleList: [],
			sexOptions: [
				{
					value: 0,
					label: '女'
				},
				{
					value: 1,
					label: '男'
				}
			],
			jobTitleOptions: [],
			areaOptions: [],
			unitOptions: [],
			actionType:'新建用户',
			userinfo:JSON.parse(sessionStorage.getItem('userInfo') || 'null') 
		};
	},
	async created() {
		let that = this
		// 获取区域树
		await this.getAreaTree();
		// 获取职称列表
		await this.getPlatformInformationData();
		if (this.userinfo) {
			// 处理数据
			console.log(this.userinfo);
			let data = this.userinfo
			// 处理区域和单位
			if (data.regionId) {//区域ID没有时
				await this.getUnitListByArea(data.regionId)
				let isHasUnit = this.unitOptions.some(item=>{
					return item.id == data.unitId
				})
				if (!isHasUnit) {//单位ID不存在时
					this.$message.error('你的单位已经不存在数据库中！请联系管理员！')
					data.unitId = ''
				}
				let lastestId = data.regionId
				data.regionId = [lastestId]
				getAllAreaIdByRecurve(this.areaOptions,lastestId)
			}else{
				data.regionId = []
				data.unitId = ''
			}
			// 处理职称
			data.rank = +data.rank
			console.log('处理后数据',data);
			this.ruleForm = data
			
			// 通过最后一级区域ID获取所有区域ID
			function getAllAreaIdByRecurve(AreaList,lastestId){
				AreaList.forEach(item=>{
					if (item.id == lastestId) {
						if (item.parentId!==0) {
							data.regionId.unshift(item.parentId)
							getAllAreaIdByRecurve(that.areaOptions, item.parentId)
						}
					}else{
						if (item.children) {
							if (item.children.length>0) {
								getAllAreaIdByRecurve(item.children, lastestId)
							}
						}
					}
				})
			}
			
		}else{
			this.$message.error('数据错误！')
		}
		
	},
	methods: {
		// 获取区域树结构
		async getAreaTree() {
			const res = await getAreaTree();
			if (res.code == 200) {
				this.areaOptions = res.data;
			} else {
				this.$message.error(res.msg);
			}
		},
		// 获取职称列表
		async getPlatformInformationData() {
			const res = await getPlatformInformationData(7);
			if (res.code == 200) {
				this.jobTitleOptions = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 根据区域ID获取单位列表
		async getUnitListByArea(id) {
			const res = await getUnitListByArea(id);
			if (res.code == 200) {
				console.log('单位列表', res);
				this.unitOptions = res.data;
			} else {
				this.$message.error(res.msg);
			}
		},
		// 获取角色列表
		// async getRoleList() {
		// 	const res = await getRoleList();
		// 	if (res.code == 200) {
		// 		console.log('角色列表', res);
		// 		this.roleList = res.data;
		// 	} else {
		// 		this.$message.error(res.data);
		// 	}
		// },
		changeData(name, data) {
			this.ruleForm[name] = data;
		},
		// 根据ID获取用户详情
		async getUserDetailById(id){
			const res = await getUserDetail(id)
			if (res.code == 200) {
				console.log('用户详情',res);
         await this.getUnitListByArea(res.data.regionId);
        // 处理角色数据
        if (res.data.roleId) {
          res.data.roleId = res.data.roleId.split(",").map(Number);
        } else {
          res.data.roleId = [];
        }
				// 处理是否禁用
				res.data.state = res.data.state == 1? true:false
				// 将职称变成数值
				if (res.data.rank) {
					res.data.rank = +res.data.rank
				}
				// 添加确认密码数据
				res.data.verifyPassword = ''
				res.data.password = ''
				this.ruleForm = res.data
				console.log('回显',this.ruleForm);
			}else{
				this.$message.error(res.msg)
			}
		},
		// 新建用户
		newUser() {
			this.$refs.ruleForm.validate(valid=>{
				if (valid) {
					// 处理角色数据
          // if (this.ruleForm.roleId && this.ruleForm.roleId.length > 0) {
          //   this.ruleForm.roleId = this.ruleForm.roleId.join(",");
          // } else {
          //   this.ruleForm.roleId = "";
          // }
					delete this.ruleForm.roleId
					// 处理地区数据
					if (this.ruleForm.regionId instanceof Array) {
						let regionId = this.ruleForm.regionId[this.ruleForm.regionId.length - 1];
						this.ruleForm.regionId = regionId;
					}
					// 处理状态
					// let state = this.ruleForm.state === false ? 0 : 1;
					// this.ruleForm.state = state;
					delete this.ruleForm.state
					delete this.ruleForm.learningSection
					delete this.ruleForm.password
					delete this.ruleForm.roleList
					console.log(this.ruleForm);
					this.editUser()
				}else{
					this.$message.error('表单验证失败！')
				}
			})
		},
		// 添加用户
		async addUser() {
			const res = await addUser(this.ruleForm);
			if (res.code == 200) {
				this.$message.success('添加成功！');
				this.$router.go(-1);
			} else {
				this.$message.error(res.data);
			}
		},
		// 修改用户
		async editUser(){
			const res = await editUser(this.ruleForm)
			if (res.code == 200) {
				this.$message.success('修改成功！')
				this.getUserInfo()
				this.$router.go(-1)
			}else{
				this.$message.error(res.msg)
			}
		},
		// 区域选择
		areaChange(val) {
			if (val.length) {
				let areaId = val[val.length - 1];
				this.getUnitListByArea(areaId);
			}else{
				this.ruleForm.unitId = ''
				this.unitOptions = []
			}
		},
		goBack() {
			this.$router.go(-1);
		},
		// 用户信息
		getUserInfo() {
			getUserInfo().then(res => {
				if (res.code == 200) {
					sessionStorage.setItem('userInfo', JSON.stringify(res.data));
				} else {
					this.$message.error(res.message);
				}
			});
		},
	}
};
</script>

<style scoped lang="scss">
.explain {
  padding: 0 15px;
  font-size: 14px;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
  line-height: 36px;
  color: #000;
}
</style>
